import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";
import * as Sentry from "@sentry/browser";

import * as firebase from 'firebase';

export default action$ =>
  action$
    .ofType(Types.LOGOUT)
    .mergeMap(action =>
      firebase
        .auth()
        .signOut()
        .then(() => {

            Sentry.setUser(null);

            return Creators.logoutSucceeded()
        })
        .catch(error => Creators.logoutFailed())
    );



// WEBPACK FOOTER //
// ./src/login/epics/logoutOfFirebase.js